import { render, staticRenderFns } from "./HomeTRecentStudy.vue?vue&type=template&id=17fdef68&scoped=true&"
import script from "./HomeTRecentStudy.vue?vue&type=script&lang=ts&"
export * from "./HomeTRecentStudy.vue?vue&type=script&lang=ts&"
import style0 from "./HomeTRecentStudy.vue?vue&type=style&index=0&id=17fdef68&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17fdef68",
  null
  
)

export default component.exports